import state from "./moduleBreaksState.js";
import mutations from "./moduleBreaksMutations.js";
import actions from "./moduleBreaksActions.js";
import getters from "./moduleBreaksGetters.js";

export default {
	isRegistered: false,
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
